<template>
	<div id="main">
		<div class="bg-other user-head-info">
			<div class="user-info clearfix">
				<div class="user-pic" data-is-fans="0" data-is-follows="">
					<div class="user-pic-bg">
						<img class="img" :src="this.$store.state.sessionInfo.headimgurl" alt="">
					</div>
				</div>
				<div class="user-info-right">
					<h3 class="user-name clearfix">
						<span>{{this.$store.state.sessionInfo.wxNickName}}</span>
						</h3>
					<p class="about-info">
						<span>{{this.$store.state.sessionInfo.roleInfo.roleName}}</span>
					</p>
				</div>
				<div class="study-info clearfix">
					<div class="item follows">
						<div class="u-info-learn" title="学习时长28时11分" style="cursor:pointer;">
							<em>0</em>
							<span>学习时长 </span>
						</div>
					</div>
					<div class="item follows">
						<a href="#"><em>0</em></a>
						<span>学习次数</span>
					</div>
					<div class="item follows">
						<a href="#"><em>1</em></a>
						<span>班级</span>
					</div>
					<div class="item follows">
						<a href="#"><em>10</em></a>
						<span>学生</span>
					</div>
				</div>
			</div>
		</div>
		<div class="wrap">
			<div class="slider">
				<ul>
					<li>
						<a class="active">
							<i class="fa fa-users" aria-hidden="true"></i><span>我的班级</span><b class="icon-drop_right"></b>
						</a>
					</li>
					<li>
						<a>
							<i class="fa fa-list-ul" aria-hidden="true"></i><span>我的课程</span><b class="icon-drop_right"></b>
						</a>
					</li>
				</ul>
			</div>
			<div class="u-container">
				<div class="c-tab clearfix">
					<div class="tool-left l">
						<a class="sort-item active">全部</a>
						<a class="sort-item">直播班</a>
						<a class="sort-item">正式班</a>
						<a class="sort-item">结业班</a>
					</div>
				</div>
				<div class="all-course-main">
					<div class="allcourse-content js-course-list ">
						<div class="courseitem tl-item">
							<div class="img-box">
								<a href="//coding.imooc.com/learn/list/169.html" target="_blank">
									<img width="200" height="116" alt="Python3入门机器学习 经典算法与应用 轻松入行人工智能" src="//img4.sycdn.imooc.com/szimg/5a39cd3f0001c09805400300-360-202.jpg">
								</a>
							</div>
							<div class="info-box course-list">
								<div class="title">
									<span>实战课程</span>
									<a href="//coding.imooc.com/learn/list/169.html" class="hd" target="_blank">Python3入门机器学习 经典算法与应用 轻松入行人工智能</a>
								</div>
								<div class="study-info">
									<span class="i-left span-common">已学83%</span>
									<span class="downloads">APP下载0节</span>
									<span class="i-mid span-common">用时540小时36分</span>
									<span class="i-right span-common">学习至14-2 学习完这个课程以后怎样继续深入机器学习的...</span>
								</div>
								<div class="catog-points">
									<span class="span-common">
                                            <a href="/u/6396323/szcourses/note?course_id=169&amp;frm=allcourses">笔记 <i>0</i></a>
                                        </span>
									<span class="i-mid span-common">
                                        </span>
									<span class="i-right span-common">
                                            <a href="/u/6396323/szcourses/question/?course_id=169&amp;frm=allcourses">问答 <i></i>0</a>
                                        </span>

									<a href="http://coding.imooc.com/down/169.html" target="_blank" class="btn-red continute-btn">我的项目</a>
									<div class="moco-ico-btn js-add-to-plan" style="position: absolute;right: 130px;" data-type="2" data-tid="169">
										加入课表 </div>
									<a href="https://coding.imooc.com/lesson/169.html#mid=15180" target="_blank" class="btn-red continute-btn">继续学习</a>
								</div>
							</div>
						</div>
						<div class="courseitem tl-item">
							<div class="img-box">
								<a href="//www.imooc.com/learn/617" target="_blank">
									<img width="200" height="116" alt="PHP微信公众平台开发高级篇—群发接口" src="//img1.sycdn.imooc.com/56e10dd4000108d706000338-360-202.jpg">
								</a>
							</div>
							<div class="info-box course-list">
								<div class="title">
									<span>免费课程</span>
									<a href="//www.imooc.com/learn/617" class="hd" target="_blank">PHP微信公众平台开发高级篇—群发接口</a>
								</div>
								<div class="study-info">
									<span class="i-left span-common">已学100%</span>
									<span class="i-mid span-common">用时 7分</span>
									<span class="i-right span-common">学习至1.03 验证群发接口单文本实现</span>
								</div>
								<div class="catog-points">
									<span class="span-common">
                                            <a href="/u/6396323/notepad/617?frm=allcourses">笔记 <i>0</i></a>
                                        </span>
									<span class="i-mid span-common">
                                            <a href="/u/6396323/course/617/codes?frm=allcourses">代码 <i>0</i></a>
                                        </span>
									<span class="i-right span-common">
                                            <a href="/u/6396323/course/617/questions?frm=allcourses">问答 <i>0</i></a>
                                        </span>

									<div class="moco-ico-btn js-add-to-plan" style="position: absolute;right: 130px;" data-type="1" data-tid="617">
										加入课表 </div>
									<a href="/video/11337" target="_blank" class="btn-red continute-btn">继续学习</a>
								</div>
								<div class="share-box clearfix course-one" data-courseid="617" data-uid="6396323">
									<div class="show-btn"><i class="icon-down2"></i></div>
									<div class="share-box-con">
										<a href="javascript:;" title="删除" data-type="all" class="del"><i class="icon icon-notdisplay"></i></a>
									</div>
								</div>
							</div>
						</div>
						<div class="courseitem tl-item">
							<div class="img-box">
								<a href="//www.imooc.com/learn/955" target="_blank">
									<img width="200" height="116" alt="ES6快速入门" src="//img4.sycdn.imooc.com/5a97d4000001d97906000338-360-202.jpg">
								</a>
							</div>
							<div class="info-box course-list">
								<div class="title">
									<span>免费课程</span>
									<a href="//www.imooc.com/learn/955" class="hd" target="_blank">ES6快速入门</a>
								</div>
								<div class="study-info">
									<span class="i-left span-common">已学0%</span>
									<span class="i-mid span-common">用时 1小时29分</span>
									<span class="i-right span-common">学习至1.01 课程介绍</span>
								</div>
								<div class="catog-points">
									<span class="span-common">
                                            <a href="/u/6396323/notepad/955?frm=allcourses">笔记 <i>0</i></a>
                                        </span>
									<span class="i-mid span-common">
                                            <a href="/u/6396323/course/955/codes?frm=allcourses">代码 <i>0</i></a>
                                        </span>
									<span class="i-right span-common">
                                            <a href="/u/6396323/course/955/questions?frm=allcourses">问答 <i>0</i></a>
                                        </span>

									<div class="moco-ico-btn js-add-to-plan" style="position: absolute;right: 130px;" data-type="1" data-tid="955">
										加入课表 </div>
									<a href="/video/16703" target="_blank" class="btn-red continute-btn">继续学习</a>
								</div>
								<div class="share-box clearfix course-one" data-courseid="955" data-uid="6396323">
									<div class="show-btn"><i class="icon-down2"></i></div>
									<div class="share-box-con">
										<a href="javascript:;" title="删除" data-type="all" class="del"><i class="icon icon-notdisplay"></i></a>
									</div>
								</div>
							</div>
						</div>
						<div class="courseitem tl-item">
							<div class="img-box">
								<a href="//www.imooc.com/learn/262" target="_blank">
									<img width="200" height="116" alt="玩转Bootstrap（JS插件篇）" src="//img4.sycdn.imooc.com/5704ae5d00013c9a06000338-360-202.jpg">
								</a>
							</div>
							<div class="info-box course-list">
								<div class="title">
									<span>免费课程</span>
									<a href="//www.imooc.com/learn/262" class="hd" target="_blank">玩转Bootstrap（JS插件篇）</a>
								</div>
								<div class="study-info">
									<span class="i-left span-common">已学0%</span>
									<span class="i-mid span-common">用时 0分</span>
									<span class="i-right span-common">学习至6.01 自定义Bootstrap</span>
								</div>
								<div class="catog-points">
									<span class="span-common">
                                            <a href="/u/6396323/notepad/262?frm=allcourses">笔记 <i>0</i></a>
                                        </span>
									<span class="i-mid span-common">
                                            <a href="/u/6396323/course/262/codes?frm=allcourses">代码 <i>0</i></a>
                                        </span>
									<span class="i-right span-common">
                                            <a href="/u/6396323/course/262/questions?frm=allcourses">问答 <i>0</i></a>
                                        </span>

									<div class="moco-ico-btn js-add-to-plan" style="position: absolute;right: 130px;" data-type="1" data-tid="262">
										加入课表 </div>
									<a href="/video/5399" target="_blank" class="btn-red continute-btn">继续学习</a>
								</div>
								<div class="share-box clearfix course-one" data-courseid="262" data-uid="6396323">
									<div class="show-btn"><i class="icon-down2"></i></div>
									<div class="share-box-con">
										<a href="javascript:;" title="删除" data-type="all" class="del"><i class="icon icon-notdisplay"></i></a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		name: 'StCenterContent',
		data() {
			return {
				classList: [],
				userList: [],
				cid: null,
				cname: null,
				teacherInfo: null
			}
		},
		methods: {
			qh(cid, cname) {
				this.cid = cid
				this.cname = cname
				this.queryByClassId(this.cid)
			},
			queryByClassId(cid) {
				axios.get('/itmswcn/userClass/class/query/' + cid)
					.then(this.queryByClassIdSucc)
			},
			queryByClassIdSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					this.userList = data
					this.teacherInfo = this.userList[0].classInfo.teacherInfo
				}
			},
			tolive() {
				axios.get('/itmswcn/maintain/classLive/queryRoom/' + this.cid)
					.then(this.getRoomSucc)
			},
			getRoomSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					window.open("https://itmsw.com/live/live.html?cid=" + data.classId + "&rid=" + data.roomId + "&rstr=" + data.randStr)
				} else {
					$.alert({
						title: '',
						content: '<span class="itmsw_ft_1" style="line-height:36px;"><i class="fa fa-check-square-o"></i> 抱歉，您还没有直播课<br>&nbsp;&nbsp;&nbsp;&nbsp;详情请咨询授课老师。</span>',
						theme: 'modern',
						closeIcon: false,
						animation: 'scale',
						type: 'blue',
						boxWidth: '380px',
						useBootstrap: false,
						backgroundDismiss: true,
						buttons: {
							yes: {
								text: '确认', // text for button
								btnClass: 'itmsw_bt_confirm_3', // class for the button
								keys: ['y'], // keyboard event for button
								isHidden: false, // initially not hidden
								isDisabled: false, // initially not disabled
								action: function(yesButton) {}
							}
						}
					});
				}
			},
			tochart() {
				window.open("https://itmsw.com/chart/home.html")
			},
			getDataInfo() {
				axios.get('/itmswcn/maintain/classInfo/queryStList')
					.then(this.getDataInfoSucc)
			},
			getDataInfoSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					this.classList = data
					this.cid = data[0].id
					this.cname = data[0].className
					this.queryByClassId(this.cid)
				}
			}
		},
		mounted() {
			this.getDataInfo()
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/center/components/StCenterContent.scss';
</style>